<template>
	<div class="pages">
		<div id="Tripod" style="width:8.375rem;height: 15.75rem;margin-top: 35%;z-index: 999;">
			<img style="width: 100% ;height: 100%;" src="/images/shakeImg/qiantong.png" />
		</div>
		<div style="position: absolute;top: 0;right: 0;left: 0;bottom: 0;">
			<div class="boxs" :id="'box'+ index" v-for="(item,index) in dataAry">
				<img src="/images/shakeImg/jianZheng.png" style="width: 100%;height: 100%;" />
				<div style="position: absolute;left: 0;top: 0; width: 140px;height: 310px;display: flex;justify-content: center;">
					<div style="font-size: 15px;width:15px;display: flex;justify-content: center;text-align:center;margin-top: 50%;color: rgb(231,40,35);line-height:25px;">{{item.name}}</div>
				</div>
			</div>
		</div>
		<div style="position: absolute;top: 0;right: 160px;left: 160px;bottom: 20px;">
			<div class="Prizes" :id="'Prize' + indexs" v-for="(item,indexs) in PrizeAry">
				<img src="/images/shakeImg/jianZheng.png" style="width: 100%;height: 100%;" />
				<div style="position: absolute;left: 0;top: 0; width: 80px;height: 210px;display: flex;justify-content: center;">
					<div style="font-size: 10px;width:10px;display: flex;justify-content: center;text-align:center;margin-top: 50%;color: rgb(231,40,35);line-height:20px;">{{item.name}}</div>
				</div>
			</div>
		</div>

		<!-- 中奖过往榜单 -->
		<div style="position: absolute; left: 0;top: 0;width: 300px; no-repeat;background-size: cover;">
			<div style="position: relative;width: 100%;height: 100%;">
				<img src="/images/shakeImg/nameList.png" style="width: 100%;height: auto;font-size: 999;" />
				<div class="scor">
					<div v-for="items in allDataAry" style="width: 100%;display: flex;flex-direction: column;color: rgb(231,40,35);margin-bottom: 30px;font-weight: 600;">
						<div style="margin-bottom: 10px;">
							奖品:{{items.p_name}}
						</div>
						<div v-for="item in items.nameAry" style="width: 100%;color: rgb(231,40,35);margin-top: 5px;font-weight: 400;">
							{{item}}
						</div>
					</div>
				</div>
			</div>
			
		</div>

		<div style="position: absolute; right: 50px;bottom: 50px;width: 150px;height: 50px;" @click="reload">
			<img src="/images/shakeImg/start.png" style="width: 100%;height: 100%;" />
		</div>

	</div>
</template>

<script>
	import axios from 'axios'
	import request from '../../common/request.js'
	let that
	let interval
	let windowWidth = document.documentElement.clientWidth;
	let windowHeight = document.documentElement.clientHeight

	export default {
		name: 'shakePage',
		data() {
			return {
				dataAry: [],
				PrizeAry: [],
				allDataAry: [],
			}
		},
		created() {
			that = this
			that.getPrizeInfoAll()
			that.getUserInfor()
			interval = setInterval(() => {
				that.getUserInfor()
			}, 4000)
		},
		methods: {
			getRandomNumber() {
				let value = Math.floor(Math.random() * 10);
				return value
			},
			reload() {
				that.$router.go(0);
			},
			boxAryStyle() { //设置进球动画
				console.log('this.windowWidth1', windowWidth, document.getElementById('Tripod').offsetLeft)
				let het = document.getElementById('Tripod').offsetTop
				let TripodX = document.getElementById('Tripod').offsetLeft
				for (var i = 0; i < that.dataAry.length; i++) {
					if (document.getElementById('box' + i)) {
						var timing = {
							duration: 3500, //ms
							delay: i * 500, //ms
							iterations: 1, //1, 2, 3 ... Infinity
							direction: 'alternate', //'normal', 'reverse'等
							easing: 'linear', //'linear', 'ease-in'等
							fill: 'forwards', //'backwards', 'both', 'none', 'auto'
						};

						let box = document.getElementById('box' + i).animate([{
							top: '-100px',
							left: that.getRandomNumber() * 175 + 'px',
							transform: 'scale(2)'
						}, {
							top: (het - 300) + 'px',
							left: TripodX + 'px',
							transform: 'scale(1)'
						}, {
							top: het + 'px',
							left: TripodX + 'px',
							transform: 'scale(0.1)'
						}], timing);
					}
				}
			},
			PrizeAryStyle() { //设置出奖动画
				let het = document.getElementById('Tripod').offsetTop
				let TripodX = document.getElementById('Tripod').offsetLeft - 130
				for (var i = 0; i < that.PrizeAry.length; i++) {
					console.log('有过来', that.PrizeAry, document.getElementById('Prize' + i))
					if (document.getElementById('Prize' + i)) {
						var timing = {
							duration: 3500, //ms
							delay: i * 500, //ms
							iterations: 1, //1, 2, 3 ... Infinity
							direction: 'alternate', //'normal', 'reverse'等
							easing: 'linear', //'linear', 'ease-in'等
							fill: 'forwards', //'backwards', 'both', 'none', 'auto'
						};
						let Prize = document.getElementById('Prize' + i).animate([{
							top: '550px',
							left: TripodX + 'px',
							transform: 'scale(0.5)',
							opacity: '0'
						}, {
							top: '400px',
							left: TripodX + 'px',
							transform: 'scale(1)',
							opacity: '1'
						}, {
							top: i < 5 ? '150px' : '250px',
							left: i < 5 ? windowWidth / 5 + (windowWidth / 10 * i) + 'px' : windowWidth / 5 + (windowWidth /
								10 * (i - 5)) + 'px',
							transform: 'scale(2)'
						}], timing);
					}

				}
			},
			getUserInfor() { //获取正在摇一摇信息
				let data = {
					code: 'roll'
				}
				let requests = request.getQueryData(data || {})
				axios.post('https://test.lfwellness.cn/api_erp/Meting/get_roll_user',
					requests).then(function(data) {
					if (data.data) {
						console.log('data.data1', data.data)
						if (data.data.ResultCode == 200) {
							that.dataAry = []
							for (let var1 in data.data.Data) {
								let itmes = {
									img: data.data.Data[var1].u_url,
									id: data.data.Data[var1].u_id,
									name: data.data.Data[var1].u_name,
								}
								that.dataAry.push(itmes)
							}
							that.boxAryStyle()

						} else if (data.data.ResultCode == 151) {
							that.shakeTripod()
						}
					}
				})
			},
			getPrizeInfo() { //2.全部 3.最新
				clearInterval(interval);
				let data = {
					type: '3'
				}
				let requests = request.getQueryData(data || {})
				axios.post('https://test.lfwellness.cn/api_erp/Meting/get_win',
					requests).then(function(data) {
					console.log('data.data', data.data)
					if (data.data) {
						if (data.data.ResultCode == 200) {
							that.PrizeAry = []
							for (let var1 of data.data.Data) {
								let itmes = {
									img: var1.u_url,
									name: var1.u_name,
									nickName: var1.u_nick_name,
								}

								that.PrizeAry.push(itmes)
								console.log(that.PrizeAry)
							}
							setTimeout(() => {
								that.PrizeAryStyle()
							}, 500)

						}
					} else {

					}
				})
			},
			getPrizeInfoAll() { //2.全部 3.最新
				clearInterval(interval);
				let data = {
					type: '2'
				}
				let requests = request.getQueryData(data || {})
				axios.post('https://test.lfwellness.cn/api_erp/Meting/get_win',
					requests).then(function(data) {
					if (data.data) {
						if (data.data.ResultCode == 200) {
							for (let item of data.data.Data) {
								if (JSON.stringify(that.allDataAry).indexOf(item.p_name) > -1) {
									for (let i = 0; i < that.allDataAry.length; i++) {
										if (item.p_name == that.allDataAry[i].p_name) {
											that.allDataAry[i].nameAry.push(item.u_name)
										}
									}
								} else {
									let items = {
										p_name: item.p_name,
										nameAry: [item.u_name]
									}
									that.allDataAry.push(items)
								}
								console.log('---', that.allDataAry)
							}

						}
					}
				})
			},
			shakeTripod() {
				var timing = {
					duration: 500, //ms
					delay: 0, //ms
					iterations: 5,
				};
				let Tripod = document.getElementById('Tripod').animate([{
					transform: 'rotate(0deg)'
				}, {
					transform: 'rotate(30deg)'
				}, {
					transform: 'rotate(0deg)'
				}, {
					transform: 'rotate(-30deg)'
				}, {
					transform: 'rotate(0deg)'
				}], timing);

				setTimeout(function() {
					Tripod = undefined
					that.getPrizeInfo()
				}, 3500)
			}

		}
	}
</script>

<style>
	.pages {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		/* border: 0.0625rem solid red; */
		overflow: hidden;
		background: url(/images/shakeImg/nianBac.jpg) no-repeat;
		background-position: center 0;
		background-size: 100%;
	}

	.boxs {
		transition-property: top, left, right, transform;
		transition-duration: 3s;
		transition-delay: 0s;
		transition: all 3s;
		width: 140px;
		height: 310px;
		border-radius: 20px;
		overflow: hidden;
		position: absolute;
	}

	.Prizes {
		width: 80px;
		height: 210px;
		border-radius: 20px;
		overflow: hidden;
		position: absolute;
	}

	.scor {
		position: absolute;
		width: 100%;
		bottom: 10%;
		height: 200px;
		display: flex;
		flex-direction: column;
		align-items: center;
		overflow: auto;
	}

	.scor::-webkit-scrollbar {
		display: none;
		/* Chrome Safari */
	}
</style>
